import _ from 'underscore';
import URI from 'urijs';

const MAX_SITE_LINK_COUNT = 3;

interface ISiteLinkResponse {
  displayName: string;
  url: string;
}

// this function is similar to the one from @bingads-webui-campaign-react/with-site-map
// Add here to avoid dependency
export const findSiteMap: any = (siteMap: any, condition: (item: any) => boolean) => {
  for (let i = 0; i < _.size(siteMap); i += 1) {
    const item = siteMap[i];
    const result = condition(item) ? item : findSiteMap(item.children, condition);
    if (!_.isEmpty(result)) {
      return result;
    }
  }
  return null;
};

export const isSiteLinkAvailable = (siteMap: any[] | undefined, url: string) => {
  // backward compatible
  if (siteMap == null) {
    return true;
  }

  const result = findSiteMap(siteMap, (node: any) => {
    const linkPath = url.split('?')[0];
    const { routePrefix, absoluteRoute } = node;
    let nodePath = '';
    if (absoluteRoute && absoluteRoute.search(/^http/) !== -1) {
      nodePath = URI(absoluteRoute).path();
    } else {
      nodePath = `${routePrefix}${absoluteRoute}`;
    }

    return linkPath.toLowerCase() === nodePath.toLocaleLowerCase();
  });

  return !!result;
};

export const generateSiteLink = (siteLinkResponses: ISiteLinkResponse[]) => {
  const siteLinks = _.map(siteLinkResponses, (siteLink) => ({
    displayName: siteLink.displayName,
    url: siteLink.url,
  }));
  // @ts-ignore
  const uniqueSiteLinks = _.uniq(
    siteLinks,
    false,
    _.iteratee('url'),
  );
  return _.first(uniqueSiteLinks, MAX_SITE_LINK_COUNT);
};

export function getUserInfoFromURL() {
  const params = new URLSearchParams(window.location.search);
  const aid = params.get('aid');
  const cid = params.get('cid');
  const uid = params.get('uid');
  return { aid, cid, uid };
}
